
import { apiRequest } from './client';
import { catalogConfig } from '../config/catalog';

export default async function GetFiscal(ean) {
  let params = {
    cnpj: catalogConfig.cnpj,
    eans: [ean],
    uf: catalogConfig.uf,
    cnae: catalogConfig.cnae
  };

  return apiRequest('/fiscal/v1/dadosFiscais', { params });
}